import {pagineAiuto, pagineDelMenu, skinConCasino, skinConScommesse} from '../../moduli/leggi';
import {haLaVoce, haUnaVoce} from '../../utils/permessi';

/**
 * LE VOCI CHE MENU E TESTATA SCRIVONO TUTTE E DUE: il conto di chi e' dentro
 * e le pagine di Aiuto. Dal computer col menu in testata stanno nella voce
 * «Altro» in alto; col menu a colonna (e sul telefono, nel cassetto) stanno
 * nel menu. Una lista sola, cosi' le due non si scordano l'una dell'altra.
 */

/**
 * LE VOCI DEL CONTO SONO QUELLE DEL GETTONE (utils/permessi.js), come nelle
 * altre skin: Profilo, Movimenti, Lista scommesse, Cambio password, Cassa, Messaggi,
 * ognuna solo a chi ha la sua voce. Senza nessuna voce la lista e' vuota.
 * Le icone sono i nomi dei disegni di IconaNova, mai emoji.
 */
export function vociDelConto(t) {
  return [
    haLaVoce('SITE_PROFILE_VIEW') && {to: '/my-account/profilo', icona: 'tessera', testo: t('Profilo')},
    haLaVoce('SITE_MOVEMENTS_VIEW') && {to: '/my-account/lista-movimenti', icona: 'grafico', testo: t('Movimenti')},
    haLaVoce('SITE_BETS_VIEW') && skinConScommesse() && {to: '/my-account/lista-scommesse', icona: 'scontrino', testo: t('Lista scommesse')},
    haLaVoce('SITE_PASSWORD_MANAGE') && {to: '/my-account/sicurezza', icona: 'lucchetto', testo: t('Cambio password')},
    haUnaVoce(['SITE_DEPOSIT', 'SITE_WITHDRAW']) && {to: '/my-account/cassa', icona: 'portafoglio', testo: t('Cassa')},
    haLaVoce('SITE_MESSAGES_VIEW') && {to: '/my-account/messaggi', icona: 'busta', testo: t('Messaggi')},
  ].filter(Boolean);
}

/**
 * LE VOCI DELLA RETE, per chi ha qualcuno sotto di se': Lista utenti,
 * Giroconto e Report, ognuna solo a chi ha la sua voce nel gettone (lato
 * FRONTEND › Rete del catalogo). Un giocatore non ne ha nessuna e la lista
 * e' vuota: dove si scrive, il gruppo Rete non compare.
 *
 * PRIMA la skin Nova non le scriveva da nessuna parte: le pagine c'erano
 * (Home/Main.js, dietro ConVoce) ma dal computer nessun menu ci portava, e
 * un master coi permessi Rete tutti accesi vedeva solo il suo conto.
 */
export function vociDellaRete(t) {
  return [
    haLaVoce('SITE_NETWORK_VIEW') && {to: '/my-account/lista-utenti', icona: 'rete', testo: t('Lista utenti')},
    haLaVoce('SITE_TRANSFER') && {to: '/my-account/giroconto', icona: 'scambio', testo: t('Giroconto')},
    haLaVoce('SITE_REPORTS_VIEW') && skinConCasino() && {to: '/my-account/report', icona: 'rapporto', testo: t('Report')},
  ].filter(Boolean);
}

/**
 * LE VOCI DELLA COLONNA DEL CONTO (stile Nova, dal computer): le stesse
 * della colonna a sinistra delle pagine del conto e della tendina
 * «Account» in testata, nello stesso ordine, coi nomi e le icone a linea
 * (IconaNova) della colonna. Cassa e' d'oro. Gioco responsabile e' di tutti.
 */
export function vociColonnaConto(t) {
  return [
    haLaVoce('SITE_PROFILE_VIEW') && {to: '/my-account/profilo', icona: 'tessera', testo: t('Profilo')},
    haLaVoce('SITE_MOVEMENTS_VIEW') && {to: '/my-account/lista-movimenti', icona: 'grafico', testo: t('Movimenti')},
    haLaVoce('SITE_BETS_VIEW') && skinConScommesse() && {to: '/my-account/lista-scommesse', icona: 'scontrino', testo: t('Lista scommesse')},
    haUnaVoce(['SITE_DEPOSIT', 'SITE_WITHDRAW']) && {to: '/my-account/cassa', icona: 'portafoglio', testo: t('Cassa'), oro: true},
    haLaVoce('SITE_PASSWORD_MANAGE') && {to: '/my-account/sicurezza', icona: 'lucchetto', testo: t('Sicurezza')},
    haLaVoce('SITE_MESSAGES_VIEW') && {to: '/my-account/messaggi', icona: 'busta', testo: t('Messaggi')},
    {to: '/gioco-responsabile', icona: 'scudo', testo: t('Gioco responsabile')},
  ].filter(Boolean);
}

/** Le pagine di Aiuto accese, coi titoli della skin; quelli di serie passano dal dizionario. */
export function pagineAiutoAccese(t) {
  const TITOLI = {chiSiamo: t('Chi siamo'), regolamento: t('Regolamento'), assistenza: t('Assistenza')};
  const ITALIANI = {chiSiamo: 'Chi siamo', regolamento: 'Regolamento', assistenza: 'Assistenza'};
  return pagineAiuto().filter((p) => p.acceso).map((p) => Object.assign({}, p, {
    titolo: p.titolo === ITALIANI[p.chiave] ? TITOLI[p.chiave] : p.titolo,
  }));
}

/**
 * LE PAGINE DEL MENU ACCESE (modulo Pagine: Promozioni, Spazio VIP, Tornei,
 * fedelta', ruota, Hall of Fame), coi titoli della skin; quelli di serie
 * passano dal dizionario. Una pagina spenta non c'e': un tasto che non porta
 * da nessuna parte e' peggio di nessun tasto. `inTestata` dice quali stanno
 * fra le sezioni in alto (Promozioni, Tornei); le altre vanno sotto «Altro».
 */
export function pagineDelMenuAccese(t) {
  const TITOLI = {promozioni: t('Promozioni'), vip: t('Spazio VIP'), tornei: t('Tornei'),
    fedelta: t('Programma fedeltà'), ruota: t('Ruota della fortuna'), hallOfFame: t('Hall of Fame')};
  return pagineDelMenu().filter((p) => p.acceso).map((p) => Object.assign({}, p, {
    titolo: p.titolo === p.titoloDiSerie && TITOLI[p.chiave] ? TITOLI[p.chiave] : p.titolo,
    inTestata: p.chiave === 'promozioni' || p.chiave === 'tornei',
  }));
}
